/**
 * Re-export shim. The `QualifiedUsers` **View** (props-only) was hoisted into
 * `@solomon-apps/shared/src/widgets/yaas/programs` so external consumers (the
 * "+New Program" Viewing-Program wiki doc) can render the bare Qualified Users
 * section fixture-driven, with no wallet / RPC / orgApiFetch / router.
 *
 * The data-owning Container (`QualifiedUsersContainer`) stays app-side — it
 * still selects holders vs agents per `program.target`, maps them to
 * `Participant`s (baking in navigation), and imports this View from this path
 * unchanged. The shared `Participant` is structurally identical to the app's,
 * so the Container's list flows straight through.
 *
 * @see packages/shared/src/widgets/yaas/programs/QualifiedUsers.tsx
 */
export {
    QualifiedUsers,
    type QualifiedUsersProps
} from "@solomon-apps/shared/src/widgets/yaas/programs/QualifiedUsers";
